
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34066',
  depVersions: {
  "documents-public-ui": "static-1.34066",
  "client-types": "static-1.450",
  "documents-lib": "static-1.34071",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1963",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5430",
  "hs-test-utils": "static-1.7843",
  "hub-http": "static-1.6055",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11278",
  "I18n": "static-7.1580",
  "jasmine-immutable": "static-1.2854",
  "jasmine-runner": "static-1.6307",
  "lodash": "static-1.3",
  "quartz": "static-1.6781",
  "react": "static-7.180",
  "react-dlb": "static-1.73",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16488",
  "reporting-data": "static-1.66675",
  "reporting-testing-lib": "static-1.8608",
  "reporting-visualizations": "static-1.58751",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4603",
  "webpack-env": "static-1.54",
  "atom": "static-1.4907",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2327",
  "classnames": "static-2.10",
  "cssUtils": "static-1.744",
  "customer-data-filters-ui": "static-1.39040",
  "customer-data-objects": "static-1.7485",
  "customer-data-property-utils": "static-1.7916",
  "data-fetching-client": "static-1.9514",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4368",
  "flux-actions": "static-1.311",
  "FormsCommonComponents": "static-1.85383",
  "FormUrlGenerator": "static-2.4558",
  "foundations-components": "static-1.7596",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11586",
  "icons": "static-2.626",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6996",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3692",
  "property-translator": "static-1.5245",
  "quartz-config": "static-1.559",
  "quartz-core": "static-1.6000",
  "quick-fetch": "static-1.3773",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5210",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7999",
  "reference-resolvers-lite": "static-1.7923",
  "report-customization-components": "static-1.12620",
  "reporting-enablement": "static-1.22211",
  "reporting-reports": "static-1.66353",
  "reporting-snowflake": "static-1.55293",
  "reporting-ui-components": "static-2.63946",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4474",
  "sales-content-partitioning": "static-1.8772",
  "SalesContentIndexUI": "static-3.8954",
  "sanitize": "static-1.4311",
  "sanitize-text": "static-1.7982",
  "self-service-api": "static-1.10077",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1587",
  "signup-constants": "static-1.18498",
  "signup-ui-lego-core": "static-1.20508",
  "signup-ui-url-generator": "static-2.7872",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4607",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10830",
  "ui-addon-i18n": "static-1.10981",
  "ui-addon-react-router-dom": "static-1.9382",
  "ui-addon-upgrades": "static-9.17708",
  "ui-asset-management-lib": "static-1.10756",
  "ui-images": "static-2.1106",
  "UIComponents": "static-3.8225",
  "usage-tracker": "static-1.7172",
  "usage-tracker-container": "static-1.7162",
  "usage-tracker-core": "static-1.7022",
  "usage-tracker-public": "static-1.6983",
  "viral-links-lib": "static-1.6875",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3265",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3058",
  "quartz-webpack": "static-1.3005",
  "ai-components-ui-library": "static-1.8454",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4676",
  "foundations-theming": "static-1.4247",
  "quartz-auth": "static-1.456",
  "ui-business-units-lib": "static-1.8868",
  "usage-tracker-session-replay": "static-1.4858",
  "foundations-theming-base": "static-1.3232",
  "HeadJS": "static-2.718",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2954",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4163",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7761",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3456",
  "persist-promise": "static-1.3545",
  "reporting-client-types": "static-1.2387",
  "foundations-components-legacy": "static-1.621",
  "hs-story-utils": "static-1.9263",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9562",
  "hubspotter-http": "static-1.4514",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7085",
  "crm-message-bus": "static-1.42476",
  "customer-data-filters-ui-msw-helpers": "static-1.21475",
  "customer-data-objects-ui-components": "static-1.12848",
  "customer-data-reference-ui-components": "static-1.12984",
  "customer-data-ui-utilities": "static-1.9661",
  "framework-builder-read-service-client": "static-1.3869",
  "framework-data-schema-quick-fetch": "static-1.6614",
  "framework-data-schema-resolvers": "static-1.6709",
  "inbound-db-properties-service-client": "static-1.3710",
  "multi-account-reference-resolvers": "static-1.810",
  "onboarding-tours": "static-1.16315",
  "reporting-datasets-permissions-lib": "static-1.13168",
  "ui-addon-teams": "static-1.21289",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67731",
  "customer-data-properties": "static-1.50874",
  "forms-ai-lib": "static-1.4064",
  "forms-utils-lib": "static-1.12235",
  "foundations-components-test-utils": "static-1.5079",
  "react-dnd-compat": "static-1.4457",
  "react-tinymce": "static-1.54723",
  "tinymce-config": "static-2.53849",
  "ui-gdpr-components": "static-1.10184",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3865",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1312",
  "ui-fonts": "static-1.540",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.803",
  "mobile-manifest-mixins": "static-1.491",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.446",
  "quartz-i18n": "static-1.456",
  "quartz-routing": "static-1.211",
  "quartz-test": "static-1.456",
  "quartz-tracking": "static-1.160",
  "batch-promise": "static-1.1388",
  "external-options-client-types": "static-1.4020",
  "react-colorpicker": "static-2.10048",
  "copilot-toolkit": "static-1.10628",
  "data-quality-ui-library": "static-1.12410",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6300",
  "reporting-action-components": "static-1.40751",
  "reporting-insights-lib": "static-1.1217",
  "reporting-plugins": "static-1.10022",
  "ui-addon-draggable-compat": "static-2.4091",
  "ui-addon-opt": "static-4.8222",
  "ui-shepherd-react": "static-3.9983",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24834",
  "hubspot-apollo-client": "static-1.4717",
  "sales-templates-service-types-lib": "static-1.4028",
  "merchandise-lib": "static-1.260",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5526",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3941",
  "timezone-utils": "static-2.5081",
  "bender-build-tools": "static-1.2982",
  "chatspot-core": "static-1.20483",
  "chirp-fetch": "static-1.1719",
  "bend-plugin-foundations-theming": "static-1.2730",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9560",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3659",
  "crm-pipelines-api-client-types": "static-1.4001",
  "multi-currency-client-types": "static-1.3552",
  "getting-started-shared-tasks": "static-1.17987",
  "growth-data-modal": "static-1.5195",
  "growth-onboarding-confetti": "static-1.2909",
  "growth-onboarding-next-action-utils": "static-1.1392",
  "navigation-components": "static-1.17399",
  "onboarding-tours-client": "static-1.4529",
  "onboarding-tours-utils": "static-1.381",
  "ui-shepherd-tracker": "static-1.7364",
  "ui-universal-auth": "static-1.8753",
  "user-context": "static-1.4936",
  "cms-field-types": "static-1.4644",
  "content-icons-ui": "static-1.2167",
  "integrations-lib": "static-1.15551",
  "calling-global-api": "static-1.63803",
  "calling-internal-common": "static-1.31132",
  "calling-lifecycle-internal": "static-1.65185",
  "calling-lifecycle-messages": "static-1.57479",
  "commerce-products-lib": "static-1.8959",
  "crm-links": "static-1.6104",
  "file-manager-components": "static-1.23007",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.517",
  "inbounddb-objects-service-types": "static-1.4084",
  "meetings-icalendar-utils-lib": "static-1.469",
  "object-builder-ui-client": "static-1.48125",
  "pipeline-validation-client-types": "static-1.3825",
  "property-value-citations": "static-1.1488",
  "pulse": "static-1.353",
  "smart-property-lib": "static-1.6085",
  "tiered-pricing": "static-1.881",
  "ui-addon-iframeable": "static-1.8884",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19534",
  "tinymce-themes": "static-1.55819",
  "data-token-picker": "static-1.16106",
  "hub-http-contrib": "static-1.2880",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39934",
  "tinymce-plugins": "static-1.56963",
  "ui-addon-sales-email": "static-1.5051",
  "magpie-lib": "static-1.5431",
  "magpie-types": "static-1.4891",
  "simple-logging-lib": "static-1.2887",
  "content-assistance-lib": "static-1.7503",
  "dashboard-lib": "static-1.80779",
  "ExportDialog": "static-6.10224",
  "hubspot-prosemirror": "static-1.17704",
  "hubspot-prosemirror-plugins": "static-1.17696",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8530",
  "campaign-roi-lib": "static-1.8396",
  "feedback-loader": "static-1.28939",
  "apollo-link-hub-http": "static-2.4488",
  "hubspot-apollo-cache": "static-1.176",
  "growth-monetization-service-types": "static-1.4336",
  "nav-client-types": "static-1.2194",
  "purchase-motions-api": "static-1.5529",
  "trials-service-types": "static-1.3737",
  "growth-onboarding-next-action-components": "static-1.1420",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.562",
  "unified-auth-core-lib": "static-1.548",
  "getting-started-shared-tasks-store": "static-1.17105",
  "integrations-error-boundary-lib": "static-1.12966",
  "integrations-tracking-lib": "static-1.5425",
  "native-integrations-shared-strings": "static-1.7625",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10210",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31138",
  "shared-worker-versioning": "static-1.10876",
  "calling-usage-tracker": "static-1.6378",
  "voice-sms-access-library": "static-1.356",
  "customer-data-tracking": "static-1.6719",
  "commerce-permissions": "static-1.598",
  "products-iframe-lib": "static-1.7430",
  "products-ui-components-shared-msw-handlers": "static-1.9944",
  "location-customization-utils-lib": "static-1.8679",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3991",
  "video-components-external": "static-1.10680",
  "video-data-lib": "static-1.34338",
  "directed-graph": "static-1.776",
  "event-emitter": "static-1.784",
  "breeze-intelligence-kit": "static-1.5377",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9645",
  "fsm": "static-1.3568",
  "policy-lib": "static-1.6614",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9708",
  "navigation-messaging": "static-1.6726",
  "FileManagerLib": "static-1.38647",
  "NamespacedHubStyle": "static-2.8932",
  "FileManagerCore": "static-1.38506",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12106",
  "layout-dnd-utils": "static-1.11081",
  "react-codemirror": "static-1.10463",
  "ui-addon-emoji-picker": "static-1.9724",
  "ui-brand-identity-lib": "static-1.14137",
  "ui-addon-video-player": "static-1.8533",
  "ui-coaching-tips": "static-1.28044",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8404",
  "payment-link-components": "static-1.23040",
  "EmailSignatureEditor": "static-1.23979",
  "eligibility-engine-service-types": "static-1.3018",
  "universal-page-editor-lib": "static-1.2835",
  "calling-orchestration-schema": "static-1.35133",
  "sales-views-client-types": "static-1.4123",
  "crm-record-cards-service-types": "static-1.3479",
  "content-media-composition-data-lib": "static-1.11586",
  "content-media-compositions": "static-2.15593",
  "media-bridge-lib": "static-1.18628",
  "trellis-story-utils": "static-1.4357",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5667",
  "FileManagerImages": "static-1.36158",
  "video-components": "static-1.12683",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4368",
  "video-embed": "static-1.35172",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67806",
  "layout-data-lib": "static-1.9406",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6418",
  "commerce-tours-lib": "static-1.5771",
  "growth-onboarding-reliability": "static-1.4923",
  "sales-checkout-service-client": "static-1.3504",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21371",
  "sales-email-signature-service-client": "static-1.3680",
  "hls.js": "static-1.35",
  "social-insights-client-types": "static-1.21467",
  "outpost": "static-1.4038",
  "advanced-menus-core": "static-1.14872",
  "advanced-menus-lib": "static-1.11842",
  "ui-memberships-settings-lib": "static-1.33551",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14871",
  "simple-menus-lib": "static-1.16388"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34066",
  "client-types": "/client-types/static-1.450",
  "documents-lib": "/documents-lib/static-1.34071",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1963",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5430",
  "hs-test-utils": "/hs-test-utils/static-1.7843",
  "hub-http": "/hub-http/static-1.6055",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11278",
  "I18n": "/I18n/static-7.1580",
  "jasmine-immutable": "/jasmine-immutable/static-1.2854",
  "jasmine-runner": "/jasmine-runner/static-1.6307",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6781",
  "react": "/react/static-7.180",
  "react-dlb": "/react-dlb/static-1.73",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16488",
  "reporting-data": "/reporting-data/static-1.66675",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8608",
  "reporting-visualizations": "/reporting-visualizations/static-1.58751",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4603",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4907",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2327",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.744",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39040",
  "customer-data-objects": "/customer-data-objects/static-1.7485",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7916",
  "data-fetching-client": "/data-fetching-client/static-1.9514",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4368",
  "flux-actions": "/flux-actions/static-1.311",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85383",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4558",
  "foundations-components": "/foundations-components/static-1.7596",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11586",
  "icons": "/icons/static-2.626",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6996",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3692",
  "property-translator": "/property-translator/static-1.5245",
  "quartz-config": "/quartz-config/static-1.559",
  "quartz-core": "/quartz-core/static-1.6000",
  "quick-fetch": "/quick-fetch/static-1.3773",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5210",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7999",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7923",
  "report-customization-components": "/report-customization-components/static-1.12620",
  "reporting-enablement": "/reporting-enablement/static-1.22211",
  "reporting-reports": "/reporting-reports/static-1.66353",
  "reporting-snowflake": "/reporting-snowflake/static-1.55293",
  "reporting-ui-components": "/reporting-ui-components/static-2.63946",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4474",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8772",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8954",
  "sanitize": "/sanitize/static-1.4311",
  "sanitize-text": "/sanitize-text/static-1.7982",
  "self-service-api": "/self-service-api/static-1.10077",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1587",
  "signup-constants": "/signup-constants/static-1.18498",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20508",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7872",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4607",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10830",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10981",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9382",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17708",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10756",
  "ui-images": "/ui-images/static-2.1106",
  "UIComponents": "/UIComponents/static-3.8225",
  "usage-tracker": "/usage-tracker/static-1.7172",
  "usage-tracker-container": "/usage-tracker-container/static-1.7162",
  "usage-tracker-core": "/usage-tracker-core/static-1.7022",
  "usage-tracker-public": "/usage-tracker-public/static-1.6983",
  "viral-links-lib": "/viral-links-lib/static-1.6875",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3265",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3058",
  "quartz-webpack": "/quartz-webpack/static-1.3005",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8454",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4676",
  "foundations-theming": "/foundations-theming/static-1.4247",
  "quartz-auth": "/quartz-auth/static-1.456",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8868",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4858",
  "foundations-theming-base": "/foundations-theming-base/static-1.3232",
  "HeadJS": "/HeadJS/static-2.718",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2954",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4163",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7761",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3456",
  "persist-promise": "/persist-promise/static-1.3545",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.621",
  "hs-story-utils": "/hs-story-utils/static-1.9263",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9562",
  "hubspotter-http": "/hubspotter-http/static-1.4514",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7085",
  "crm-message-bus": "/crm-message-bus/static-1.42476",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21475",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12848",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12984",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9661",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3869",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6614",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6709",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3710",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.810",
  "onboarding-tours": "/onboarding-tours/static-1.16315",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13168",
  "ui-addon-teams": "/ui-addon-teams/static-1.21289",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67731",
  "customer-data-properties": "/customer-data-properties/static-1.50874",
  "forms-ai-lib": "/forms-ai-lib/static-1.4064",
  "forms-utils-lib": "/forms-utils-lib/static-1.12235",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5079",
  "react-dnd-compat": "/react-dnd-compat/static-1.4457",
  "react-tinymce": "/react-tinymce/static-1.54723",
  "tinymce-config": "/tinymce-config/static-2.53849",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10184",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3865",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1312",
  "ui-fonts": "/ui-fonts/static-1.540",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.803",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.446",
  "quartz-i18n": "/quartz-i18n/static-1.456",
  "quartz-routing": "/quartz-routing/static-1.211",
  "quartz-test": "/quartz-test/static-1.456",
  "quartz-tracking": "/quartz-tracking/static-1.160",
  "batch-promise": "/batch-promise/static-1.1388",
  "external-options-client-types": "/external-options-client-types/static-1.4020",
  "react-colorpicker": "/react-colorpicker/static-2.10048",
  "copilot-toolkit": "/copilot-toolkit/static-1.10628",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12410",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6300",
  "reporting-action-components": "/reporting-action-components/static-1.40751",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1217",
  "reporting-plugins": "/reporting-plugins/static-1.10022",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4091",
  "ui-addon-opt": "/ui-addon-opt/static-4.8222",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9983",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24834",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4717",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4028",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5526",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3941",
  "timezone-utils": "/timezone-utils/static-2.5081",
  "bender-build-tools": "/bender-build-tools/static-1.2982",
  "chatspot-core": "/chatspot-core/static-1.20483",
  "chirp-fetch": "/chirp-fetch/static-1.1719",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2730",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9560",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3659",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4001",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3552",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17987",
  "growth-data-modal": "/growth-data-modal/static-1.5195",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2909",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1392",
  "navigation-components": "/navigation-components/static-1.17399",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4529",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.381",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7364",
  "ui-universal-auth": "/ui-universal-auth/static-1.8753",
  "user-context": "/user-context/static-1.4936",
  "cms-field-types": "/cms-field-types/static-1.4644",
  "content-icons-ui": "/content-icons-ui/static-1.2167",
  "integrations-lib": "/integrations-lib/static-1.15551",
  "calling-global-api": "/calling-global-api/static-1.63803",
  "calling-internal-common": "/calling-internal-common/static-1.31132",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65185",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57479",
  "commerce-products-lib": "/commerce-products-lib/static-1.8959",
  "crm-links": "/crm-links/static-1.6104",
  "file-manager-components": "/file-manager-components/static-1.23007",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.517",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4084",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.469",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48125",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3825",
  "property-value-citations": "/property-value-citations/static-1.1488",
  "pulse": "/pulse/static-1.353",
  "smart-property-lib": "/smart-property-lib/static-1.6085",
  "tiered-pricing": "/tiered-pricing/static-1.881",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8884",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19534",
  "tinymce-themes": "/tinymce-themes/static-1.55819",
  "data-token-picker": "/data-token-picker/static-1.16106",
  "hub-http-contrib": "/hub-http-contrib/static-1.2880",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39934",
  "tinymce-plugins": "/tinymce-plugins/static-1.56963",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5051",
  "magpie-lib": "/magpie-lib/static-1.5431",
  "magpie-types": "/magpie-types/static-1.4891",
  "simple-logging-lib": "/simple-logging-lib/static-1.2887",
  "content-assistance-lib": "/content-assistance-lib/static-1.7503",
  "dashboard-lib": "/dashboard-lib/static-1.80779",
  "ExportDialog": "/ExportDialog/static-6.10224",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17704",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17696",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8530",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8396",
  "feedback-loader": "/feedback-loader/static-1.28939",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4488",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.176",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4336",
  "nav-client-types": "/nav-client-types/static-1.2194",
  "purchase-motions-api": "/purchase-motions-api/static-1.5529",
  "trials-service-types": "/trials-service-types/static-1.3737",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1420",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.562",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.548",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17105",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12966",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5425",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7625",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10210",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31138",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10876",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6378",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.356",
  "customer-data-tracking": "/customer-data-tracking/static-1.6719",
  "commerce-permissions": "/commerce-permissions/static-1.598",
  "products-iframe-lib": "/products-iframe-lib/static-1.7430",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9944",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8679",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3991",
  "video-components-external": "/video-components-external/static-1.10680",
  "video-data-lib": "/video-data-lib/static-1.34338",
  "directed-graph": "/directed-graph/static-1.776",
  "event-emitter": "/event-emitter/static-1.784",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5377",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9645",
  "fsm": "/fsm/static-1.3568",
  "policy-lib": "/policy-lib/static-1.6614",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9708",
  "navigation-messaging": "/navigation-messaging/static-1.6726",
  "FileManagerLib": "/FileManagerLib/static-1.38647",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8932",
  "FileManagerCore": "/FileManagerCore/static-1.38506",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12106",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11081",
  "react-codemirror": "/react-codemirror/static-1.10463",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9724",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14137",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8533",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28044",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8404",
  "payment-link-components": "/payment-link-components/static-1.23040",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3018",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2835",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35133",
  "sales-views-client-types": "/sales-views-client-types/static-1.4123",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3479",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11586",
  "content-media-compositions": "/content-media-compositions/static-2.15593",
  "media-bridge-lib": "/media-bridge-lib/static-1.18628",
  "trellis-story-utils": "/trellis-story-utils/static-1.4357",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5667",
  "FileManagerImages": "/FileManagerImages/static-1.36158",
  "video-components": "/video-components/static-1.12683",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4368",
  "video-embed": "/video-embed/static-1.35172",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67806",
  "layout-data-lib": "/layout-data-lib/static-1.9406",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6418",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5771",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4923",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3504",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21371",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3680",
  "hls.js": "/hls.js/static-1.35",
  "social-insights-client-types": "/social-insights-client-types/static-1.21467",
  "outpost": "/outpost/static-1.4038",
  "advanced-menus-core": "/advanced-menus-core/static-1.14872",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11842",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33551",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14871",
  "simple-menus-lib": "/simple-menus-lib/static-1.16388"
}
};
